import React, { useState } from "react";

import { Skeleton, SkeletonProps } from "@mui/material";
import { IoMdCloseCircle } from "react-icons/io";

import useStyles from "./styles";

type Props = {
  src?: string;
  className?: string;
  skeleton?: SkeletonProps;
  onRemove?: () => void;
  onImageClick?: () => void;
};

const ImageLoading = (props: Props) => {
  const { src, className, skeleton, onRemove, onImageClick } = props;

  const classes = useStyles();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const renderRemoveIcon = () => {
    if (onRemove)
      return <IoMdCloseCircle onClick={onRemove} color="#F97066" className={classes.removeIcon} />;
  };

  const renderImage = () => {
    if (src) {
      return (
        <>
          {isLoading && (
            <Skeleton
              variant="rectangular"
              className={classes.skeleton}
              width={240}
              height={300}
              {...(skeleton || {})}
            />
          )}
          <div className={isLoading ? classes.hide : undefined}>
            {renderRemoveIcon()}
            <div className={onRemove ? classes.removeIconImage : undefined}>
              <img
                src={src}
                onLoad={() => setIsLoading(false)}
                className={className}
                onClick={() => onImageClick && onImageClick()}
              />
            </div>
          </div>
        </>
      );
    }

    return <></>;
  };

  return renderImage();
};

export default ImageLoading;
